<template>
  <payment-review-modal
    id="topup-review-modal"
    :form-data="modal.data.formData"
    :transaction-type="modal.data.transactionType"
    :fee-amount="modal.data.feeAmount"
  >
    <data-divider />
    <profile-data-in-modal
      v-if="!modal.data.formData.unidentifiedRecipient"
      :transaction-party-type="TRANSACTION_PARTY_TYPES.RECIPIENT"
      :profile="modal.data.recipient"
      :selected-account="modal.data.recipientAccount"
    />
    <v-layout
      row
      align-center
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense font-weight-medium black--text">Unidentified recipient</v-subheader>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Recipient IBAN</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-recipient">{{ modal.data.formData.recipient }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Unidentified recipient info/comment</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-unidentified-comment">{{ modal.data.formData.unidentifiedRecipientComment }}</div>
      </v-flex>
    </v-layout>
    <data-divider />
    <external-data-in-modal
      :transaction-type="modal.data.transactionType"
      :transaction-data="modal.data.formData"
    />
    <data-divider />
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Type</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-urgency">{{ modal.data.formData.urgency | urgencyLabel }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Channel</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-channel">{{ modal.data.formData.channel | channel }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Reference</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-reference">{{ modal.data.formData.referenceNumber }}</div>
      </v-flex>
    </v-layout>
  </payment-review-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Constants
  import { TRANSACTION_PARTY_TYPES } from '@/models/Transaction'

  // Components
  import PaymentReviewModal from '@/components/payments/ReviewModal/PaymentReviewModal'
  import ProfileDataInModal from '@/components/payments/ReviewModal/ProfileDataInModal'
  import ExternalDataInModal from '@/components/transactions/ExternalDataInModal'
  import DataDivider from '@/components/payments/ReviewModal/DataDivider'

  export default {
    name: 'TopupReviewModal',
    components: {
      PaymentReviewModal,
      ProfileDataInModal,
      ExternalDataInModal,
      DataDivider
    },
    data () {
      return {
        TRANSACTION_PARTY_TYPES
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    }
  }
</script>
